import { ProgressBar } from "./AdminComponents";

const AdminUsage = ({ ana, period, setPeriod }) => (
  <div className="space-y-6" data-testid="admin-usage-tab">
    <div className="flex items-center justify-between">
      <h2 className="text-lg font-semibold text-white">Feature Usage</h2>
      <div className="flex gap-2">
        {[7, 30, 90].map((p) => (
          <button key={p} onClick={() => setPeriod(p)}
            className={`px-3 py-1.5 rounded-lg text-xs font-medium ${period === p ? "bg-violet-500/20 text-violet-300 border border-violet-500/30" : "bg-white/5 text-slate-400 border border-white/5"}`}
          >{p} days</button>
        ))}
      </div>
    </div>

    <div className="bg-slate-900/70 rounded-xl border border-white/5 p-5">
      <div className="space-y-4">
        {Object.entries(ana.feature_usage || {})
          .sort((a, b) => b[1] - a[1])
          .map(([feature, count]) => {
            const pct = Math.round((count / Math.max(ana.feature_total || 1, 1)) * 100);
            return (
              <div key={feature} className="space-y-1.5">
                <div className="flex justify-between text-sm">
                  <span className="text-slate-200">{feature}</span>
                  <span className="text-white font-semibold">
                    {count} <span className="text-slate-500 font-normal text-xs">({pct}%)</span>
                  </span>
                </div>
                <ProgressBar pct={pct} color="violet" />
              </div>
            );
          })}
      </div>
    </div>
  </div>
);

export default AdminUsage;
